// extracted by mini-css-extract-plugin
export var box = "_2h-2";
export var checkboxControl = "_2h-0";
export var checkboxRow = "_2h-9";
export var checked = "_2h-3";
export var descriptionSpacer = "_2h-b";
export var disabled = "_2h-4";
export var icon = "_2h-7";
export var input = "_2h-1";
export var labelSpacer = "_2h-a";
export var medium = "_2h-6";
export var small = "_2h-5";
export var text = "_2h-8";